import $ from 'jquery'
import { isShow } from '../_variables'
import Screen from './screen'

const screen = new Screen()

export default class Lnavi {
  constructor() {
    this.elm = document.querySelector('html')
  }

  init() {
    this.lnavi()
  }

  // SP menu
  lnavi() {
    $('.l-lnavi__content').each((idx, elLnavi) => {
      const $this = $(elLnavi)
      const $btnLnavi = $this.find('.l-lnavi__textBox')
      const $contentLnavi = $this.find('.l-lnavi__detail')

      $btnLnavi.on('click', () => {
        if (!screen.isPC) {
          $contentLnavi.stop().fadeToggle()
          $this.toggleClass(isShow)

          if ($this.hasClass(isShow)) {
            screen.lock()
          } else {
            screen.unlock()
          }
        }
      })

      // resize
      $(window).on('breakpointChange', () => {
        if (screen.isPC) {
          $contentLnavi.removeAttr('style')
          $this.removeClass(isShow)
          screen.unlock()
        }
      })
    })
  }
}
